/* eslint-disable consistent-return */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState,useMemo } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button, Tooltip } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import {
  getRebateProgramCode,
  setCms64Data,
  getMaxQuarterForRebatePrg,
  listCmsReportGroups,
  getRebateProgramByCMSReportGrp,
  setErrorMessagesData,
  getReportQuarter,
  getInvoiceStartQtr,
  getPreviousQtr,
  dispatchRebateProgByCMSReportGrp,
  setCMSReportingGrps,
  dispatchDetailScreenObj,
} from '../Store/actions';
import { getUserDefaults } from '../../../../UserDefault/store/actions';
import {
  REBATE_PROGRAM_REQUIRED,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  REBATE_REPORTING_REQUIRED,
} from '../../../../../../SharedModules/Errors/constantMessageData';
import {
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
  checkQuarterValidation,
  redirectURLLink,
} from '../../../../../../SharedModules/CommonUtilities/commonUtilities';
import DisplayErrorMessages from '../../../../../../SharedModules/Errors/ErrorMessages';
import CustomSeparator from '../../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../../../SharedModules/Spinner/SpinnerNew';
import CommonModal from '../../../../../../SharedModules/Dialog/CommonModal';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../../../SharedModules/utilities/utilities';
import GroupOfRebateProgramComponent from '../../../../../../SharedModules/CustomGroupOfRebateProgram/GroupOfRebateProgramComponent';

function ReqInitCorrectCmsReport() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [successMessages, setSuccessMessages] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);

  const [redirect, setRedirect] = useState(false);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const createCms64Data = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.createCms64Data
  );
  const rebateProgramCode = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.rebateProgramCode?.data
  );

  const createCmsReport = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer.createCmsReport
  );
  const defaultQtr = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.defaultQtrCUF?.data
  );
  const cmsReportingGrps = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.cmsReportingGrps?.data
  );
  const rebatePrgByCMS = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.rebatePrgByCMS?.data
  );
  const errorMessagesData = useSelector(
    (state) => state.sharedState.CreateUtilizationTapeReducer.errorMessages
  );
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const defaultRebateProgramCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));
  const getCmsReportGroups = (value) => dispatch(listCmsReportGroups(value));

  const getRebateProgramCodeValue = (values) => {
    dispatch(getRebateProgramCode(values));
  };

  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const groupRebateProgramData = useMemo(() => {
    if (
      createCms64Data?.cmsReportingGrps === '' ||
      createCms64Data?.cmsReportingGrps === '-1' ||
      !Array.isArray(rebatePrgByCMS)
    ) {
      return [];
    }

    return rebatePrgByCMS.map((item) => ({
      ...item,
      rebateProgramCd: item?.rebateProgramCode || '',
      shortDescr: item?.shortDesc || '',
    }));
  }, [createCms64Data?.cmsReportingGrps, rebatePrgByCMS]);
  useEffect(() => {
    setSuccessMessages([]);
    getUserDefaultValues(logInUser);
    if (defaultRebateProgramCd !== '' && defaultRebateProgramCd) {
      dispatch(
        getMaxQuarterForRebatePrg({
          rebateProgramCd: defaultRebateProgramCd,
        })
      );
    }
    dispatch(
      setCms64Data({
        ...createCms64Data,
        quarter: createCms64Data?.quarter || defaultQtr,
        planType: createCms64Data?.planType || UserDefaultValues?.planTypeCd,
        rebateProgramCd:
          createCms64Data?.rebateProgramCd || defaultRebateProgramCd,
        selectBy: createCms64Data.selectBy || 'single',
      })
    );
  }, []);
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(
      setCms64Data({
        ...createCms64Data,
        fullScreenView: !fullScreenView,
      })
    );
  };
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesData?.length > 0) {
      tabHighLigther('/reqInitCorrectCmsReport', true);
    } else {
      tabHighLigther('/reqInitCorrectCmsReport', false);
    }
  }, [JSON.stringify(errorMessagesData)]);

  useEffect(() => {
    if (
      createCms64Data?.cmsReportingGrps &&
      createCms64Data?.cmsReportingGrps !== '-1' &&
      createCms64Data?.quarter
    ) {
      const rebatePrgByCMSPayload = {
        rebateProgramCode: createCms64Data?.cmsReportingGrps,
        quarter: createCms64Data?.quarter,
      };
      dispatch(getRebateProgramByCMSReportGrp(rebatePrgByCMSPayload));
    }
  }, [createCms64Data?.cmsReportingGrps]);

  useEffect(() => {
    if (createCms64Data?.planType) {
      getRebateProgramCodeValue(createCms64Data?.planType);
    }
  }, [createCms64Data?.planType]);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const fetchGroupOfRebateProgramList = (val) => {
    if (checkQuarterValidation(val)) {
      getCmsReportGroups(val);
    }
  };
  useEffect(() => {
    if (createCmsReport && typeof createCmsReport === 'string') {
      setConfirmModal(createCmsReport);
    } else if (redirect) {
      redirectToClose();
    }
    return () => {
      setRedirect(false);
      clearTimeout(window.redract_set);
    };
  }, [createCmsReport, redirect]);
  const handleCreateUtilTapeData = (e) => {
    dispatch(setErrorMessagesData([]))
    if (
      e.target.name === 'selectBy' &&
      createCms64Data?.quarter &&
      e.target.value === 'group'
    )
      fetchGroupOfRebateProgramList(createCms64Data?.quarter);
    dispatch(
      setCms64Data({
        ...createCms64Data,
        [e.target.name]: e.target.value,
        ...('planType' in createCms64Data &&
          e.target.name === 'planType' && { rebateProgramCd: '-1' }),
      })
    );
  };

  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesData || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateProgramCd',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (type === 'cmsReportingGrps') {
      if (!value || value === '-1') {
        localErr = localErr?.filter(
          (item) => item.field !== 'cmsReportingGrps'
        );
        localErr.push({
          field: 'cmsReportingGrps',
          errorType: 'cmsReportingGrps',
          message: REBATE_REPORTING_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'cmsReportingGrps');
      }
    }
    if (type === 'quarter') {
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          dispatch(
            setCms64Data({
              ...createCms64Data,
              [type]: value,
            })
          );
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        if (type === 'quarter') {
          localErr.push({
            field: 'quarter',
            errorType: 'required',
            message: QUARTER_VALUE_REQUIRED,
          });
        }
      }
    }

    const unique = [...new Set(localErr)];
    dispatch(setErrorMessagesData(unique));
    dispatch(
      setCms64Data({
        ...createCms64Data,
        [type]: value,
      })
    );
  };
  const validateCreateCmsReq = () => {
    let localErr = [];
    if (createCms64Data?.selectBy === 'single') {
      if (
        !createCms64Data?.rebateProgramCd ||
        createCms64Data?.rebateProgramCd === '-1'
      ) {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateProgramCd',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (createCms64Data?.selectBy === 'group') {
      if (
        createCms64Data?.cmsReportingGrps === '-1' ||
        !createCms64Data?.cmsReportingGrps
      ) {
        localErr = localErr?.filter(
          (item) => item.field !== 'cmsReportingGrps'
        );
        localErr.push({
          field: 'cmsReportingGrps',
          errorType: 'cmsReportingGrps',
          message: REBATE_REPORTING_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'cmsReportingGrps');
      }
    }
    if (
      createCms64Data?.quarter &&
      !_.isEmpty(createCms64Data?.quarter) &&
      !_.isNaN(createCms64Data?.quarter)
    ) {
      const indexOf = !_.isEmpty(localErr)
        ? _.findIndex(localErr, {
            field: 'quarter',
            errorType: 'required',
          })
        : null;

      if (!_.isNull(indexOf) && indexOf >= 0) {
        localErr.splice(indexOf, 1);
      }
      if (
        quarterTest1.test(createCms64Data?.quarter) ||
        quarterTest2.test(createCms64Data?.quarter)
      ) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'invalidFormat',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        localErr = localErr.filter((item) => item.field !== 'quarter');
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        localErr.push({
          field: 'quarter',
          errorType: 'invalidFormat',
          message: VALIDATE_QUARTER_VALUE,
        });
      }
    } else {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(setErrorMessagesData(unique));
    if (localErr.length > 0) {
      return false;
    }
    return true;
  };

  const runProcess = async (
    invoiceStartFlag = false,
    qtrFlag = false,
    cmsFlag = false
  ) => {
    const str = rebatePrgByCMS?.map((item) => {
      return item.rebateProgramCode;
    });
    const reqInvoiceCalcDataPayload2 = {
      // selectBy: createCms64Data?.selectBy,
      rpc:
        createCms64Data?.selectBy === 'group'
          ? str
          : [createCms64Data?.rebateProgramCd],
      rptQtr: createCms64Data?.quarter,
      codeDomainKey: 'STATE_CD',
      invoiceStartFlag: invoiceStartFlag,
      qtrFlag: qtrFlag,
      cmsFlag: cmsFlag,
    };

    await dispatch(getReportQuarter(reqInvoiceCalcDataPayload2));
    await dispatch(
      getPreviousQtr(createCms64Data.quarter ? createCms64Data.quarter : '')
    );
    setRedirect(true);
    // window.redract_set = setTimeout(() => {
    //   setRedirect(false);
    // }, 2000);
  };
  const redirectToClose = () => {
    if (createCmsReport && typeof createCmsReport === 'string') {
      return setConfirmModal(createCmsReport);
    }
    if (
      createCmsReport &&
      createCmsReport.headerList &&
      createCmsReport.reportQtrDetailList
    ) {
      redirectURLLink(
        '/initCorrectCms64Report',
        'Init Correct Cms64 Report',
        history
      );
    }
  };
  function checkData() {
    if (validateCreateCmsReq()) {
      const reqInvoiceCalcDataPayload2 = {
        rebateProgramCd: createCms64Data?.rebateProgramCd,
        rptQtr: createCms64Data.quarter ? createCms64Data.quarter : '',
        codeDomainKey: 'STATE_CD',
        invoiceStartFlag: false,
        qtrFlag: false,
        cmsFlag: false,
      };
      dispatch(
        dispatchDetailScreenObj({
          ...createCms64Data,
          groupOfRebateProgramData: rebatePrgByCMS,
        })
      );
      getInvoiceStartQtr(reqInvoiceCalcDataPayload2, (res) => {
        const qtr_r = `${createCms64Data.quarter.slice(
          2
        )}${createCms64Data.quarter.charAt(0)}`;
        const is_valid = qtr_r < res;
        if (res === '') {
          redirectURLLink(
            '/initCorrectCms64Report',
            'Init Correct Cms64 Report',
            history
          );
        } else if (/^[0-9]+$/.test(res)) {
          runProcess(is_valid, is_valid);
          setRedirect(false);
        } else {
          setConfirmModal(res);
        }
      });
    }
  }

  return (
    <div className="tabs-container">
      <div className="tBillPanel custom-check">
        <div className="panel tBillPanel-space pb-0">
          <Spinner load={spinnerLoader} />
          <DisplaySuccessMessages successMessages={successMessages} />
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesData?.length > 0
                  ? _.map(errorMessagesData, (l) => l.message)
                  : []
              ),
            ]}
          />
          <CustomSeparator
            parent1="System"
            parent2="Req Init Correct CMS64 Rpt"
          />
          <div className="panel mb-3">
            <div className="row">
              <div className="col-sm-8">
                <fieldset className="custom-fieldset">
                  <legend
                    className="same-font-family"
                    id="demo-row-radio-buttons-group-select-by-label"
                  >
                    Selected by
                  </legend>
                  <div className="form-wrapper p-0 mt-2">
                    <div className="mui-custom-form input-md field-xl">
                      <div className="sub-radio no-margin">
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-select-by-label"
                            name="selectBy"
                            onChange={handleCreateUtilTapeData}
                            value={createCms64Data?.selectBy || 'single'}
                            required
                          >
                            <FormControlLabel
                              style={{ marginRight: '170px' }}
                              value="single"
                              control={<Radio />}
                              label="Single Rebate Program"
                              data-test="singleRbtPrg"
                            />
                            <FormControlLabel
                              value="group"
                              control={<Radio />}
                              label="Group of Rebate Programs"
                              data-test="grpRbtPrg"
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-sm-4 mt-2">
                <fieldset className="custom-fieldset">
                  {/* <legend className='same-font-family'></legend> */}
                  <div className="form-wrapper p-0 mt-2">
                    <div className="mui-custom-form input-md field-xl">
                      <div>
                        <TextField
                          id="quarter"
                          label="Quarter"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{ maxLength: 6, id: 'quarter' }}
                          required
                          name="quarter"
                          value={createCms64Data?.quarter}
                          onChange={handleCreateUtilTapeData}
                          onBlur={(e) => {
                            handleOnblurEvent(
                              'quarter',
                              autoFormateDate(e?.target?.value?.toUpperCase())
                            );
                            fetchGroupOfRebateProgramList(e?.target?.value);
                            dispatch(
                              setCms64Data({
                                ...createCms64Data,
                                quarter: autoFormateDate(
                                  e?.target?.value?.toUpperCase()
                                ),
                                cmsReportingGrps: '-1',
                              })
                            );
                            dispatch(dispatchRebateProgByCMSReportGrp([]));
                            dispatch(setCMSReportingGrps([]));
                          }}
                          className={
                            errorMessagesData?.length > 0
                              ? _.map(errorMessagesData, (l) =>
                                  l.field === 'quarter'
                                    ? 'mandate-fields'
                                    : null
                                )
                              : null
                          }
                          helperText={
                            errorMessagesData?.length > 0
                              ? _.map(errorMessagesData, (l) =>
                                  l.field === 'quarter' ? l.message : null
                                )
                              : null
                          }
                          error={
                            errorMessagesData?.length > 0
                              ? _.map(errorMessagesData, (l) =>
                                  l.field == 'quarter' ? l.message : null
                                )
                              : null
                          }
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="row">
              {createCms64Data?.selectBy === 'single' ? (
                <>
                  <div className="col-sm-5">
                    <fieldset className="custom-fieldset">
                      <legend
                        className="same-font-family"
                        id="demo-row-radio-buttons-group-plan-type-label"
                      >
                        Plan Type
                      </legend>
                      <div className="form-wrapper p-0 mt-2">
                        <div className="mui-custom-form input-md field-xl">
                          <div className="sub-radio no-margin">
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-plan-type-label"
                                name="planType"
                                onChange={handleCreateUtilTapeData}
                                value={createCms64Data?.planType}
                                required
                              >
                                <FormControlLabel
                                  style={{ marginRight: '50px' }}
                                  value="FD"
                                  control={<Radio />}
                                  label="Medicaid"
                                  data-test="Medicaid"
                                />
                                <FormControlLabel
                                  // style={{ marginRight: '40px' }}
                                  value="COMM"
                                  control={<Radio />}
                                  label="Commercial"
                                  data-test="Commercial"
                                />
                                <FormControlLabel
                                  style={{ marginRight: '79px' }}
                                  value="ST"
                                  control={<Radio />}
                                  label="State"
                                  data-test="State"
                                />
                                <FormControlLabel
                                  value="SUPP"
                                  control={<Radio />}
                                  label="Supplemental"
                                  data-test="Supplemental"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-sm-3 mt-2">
                    <fieldset className="custom-fieldset">
                      {/* <legend className='same-font-family'></legend> */}
                      <div className="form-wrapper p-0 mt-2">
                        <div className="mui-custom-form input-md field-xl">
                          <div>
                            {/* <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="labeler-tooltip">
                                  {`${createCms64Data?.rebateProgramCd} | ${
                                    createCms64Data?.rebateProgramSelObj[0]
                                      ?.shortDescr || ''
                                  }`}
                                </Tooltip>
                              }
                            > */}
                            <TextField
                              id="rebateProgramCd"
                              label="Rebate Program"
                              fullWidth
                              select
                              placeholder=""
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{ id: 'rebateProgramCd' }}
                              required
                              onChange={handleCreateUtilTapeData}
                              name="rebateProgramCd"
                              value={createCms64Data?.rebateProgramCd || '-1'}
                              className={
                                errorMessagesData?.length > 0
                                  ? _.map(errorMessagesData, (l) =>
                                      l.field === 'rebateProgramCd'
                                        ? 'mandate-fields'
                                        : null
                                    )
                                  : null
                              }
                              onBlur={(e) =>
                                handleOnblurEvent(
                                  'rebateProgramCd',
                                  e?.target?.value
                                )
                              }
                              error={
                                errorMessagesData?.length > 0
                                  ? _.map(errorMessagesData, (l) =>
                                      l.field === 'rebateProgramCd'
                                        ? l.message
                                        : null
                                    )
                                  : null
                              }
                              helperText={
                                errorMessagesData?.length > 0
                                  ? _.map(errorMessagesData, (l) =>
                                      l.field === 'rebateProgramCd'
                                        ? l.message
                                        : null
                                    )
                                  : null
                              }
                            >
                              <MenuItem
                                key=""
                                value="-1"
                                className="frr-dropdown-blank-item"
                              />
                              {rebateProgramCode?.length > 0
                                ? rebateProgramCode?.map((item) => {
                                    return (
                                      <MenuItem
                                        key={item.rebateProgramCd}
                                        value={item.rebateProgramCd}
                                      >
                                        {item.rebateProgramCd} {'|'}{' '}
                                        {item.shortDescr}
                                      </MenuItem>
                                    );
                                  })
                                : null}
                            </TextField>
                            {/* </OverlayTrigger> */}
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </>
              ) : null}

              {createCms64Data?.selectBy === 'group' ? (
                <>
                  <div className="col-8 mt-2">
                    <fieldset className="custom-fieldset">
                      {/* <legend className='same-font-family'></legend> */}
                      <div className="form-wrapper p-0 mt-2">
                        <div className="mui-custom-form input-md field-xl">
                          <div>
                            <TextField
                              id="cmsReportingGrps"
                              label="CMS Reporting Group"
                              fullWidth
                              select
                              placeholder=""
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                id: 'cmsReportingGrps',
                              }}
                              required
                              onChange={handleCreateUtilTapeData}
                              name="cmsReportingGrps"
                              value={createCms64Data?.cmsReportingGrps || '-1'}
                              onBlur={(e) => {
                                let localErr = errorMessagesData || [];
                                if (
                                  !e.target.value ||
                                  e.target.value === '-1'
                                ) {
                                  localErr = localErr?.filter(
                                    (item) => item.field !== 'cmsReportingGrps'
                                  );
                                  localErr.push({
                                    field: 'cmsReportingGrps',
                                    errorType: 'cmsReportingGrps',
                                    message: REBATE_REPORTING_REQUIRED,
                                  });
                                } else {
                                  localErr = localErr.filter(
                                    (item) => item.field !== 'cmsReportingGrps'
                                  );
                                }
                                const unique = [...new Set(localErr)];
                                dispatch(setErrorMessagesData(unique));
                              }}
                              className={
                                errorMessagesData?.length > 0
                                  ? _.map(errorMessagesData, (l) =>
                                      l.field == 'cmsReportingGrps'
                                        ? 'mandate-fields'
                                        : null
                                    )
                                  : null
                              }
                              error={
                                errorMessagesData?.length > 0
                                  ? _.map(errorMessagesData, (l) =>
                                      l.field === 'cmsReportingGrps'
                                        ? l.message
                                        : null
                                    )
                                  : null
                              }
                              helperText={
                                errorMessagesData?.length > 0
                                  ? _.map(errorMessagesData, (l) =>
                                      l.field === 'cmsReportingGrps'
                                        ? l.message
                                        : null
                                    )
                                  : null
                              }
                            >
                              <MenuItem
                                key=""
                                value="-1"
                                className="frr-dropdown-blank-item"
                              />
                              {cmsReportingGrps &&
                              cmsReportingGrps.length &&
                              cmsReportingGrps.length > 0
                                ? cmsReportingGrps.map((item) => {
                                    return (
                                      <MenuItem key={item} value={item}>
                                        {item}
                                      </MenuItem>
                                    );
                                  })
                                : null}
                            </TextField>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-4 btn-wrapper mt-4">
                    <div className="float-right hide-on-print">
                      <Button
                        className="btn-success same-font-family frr-btn-width-17 mt-4"
                        onClick={() => {
                          checkData();
                        }}
                      >
                        <SVGComponent iconName="Create-new-icon" /> Process
                      </Button>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
            {createCms64Data?.selectBy === 'single' && (
              <div className="row float-right">
                <div className="btn-wrapper mb-2">
                  <div className="mt-1 ml-4 hide-on-print">
                    <Button
                      className="btn-success same-font-family frr-btn-width-17 mt-4"
                      onClick={() => {
                        checkData();
                      }}
                    >
                      <SVGComponent iconName="Create-new-icon" /> Process
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {createCms64Data?.selectBy === 'group' && (
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk">
            <GroupOfRebateProgramComponent
              fullScreenView={fullScreenView}
              handleFullScreenView={handleFullScreenView}
              data={
                // createCms64Data?.cmsReportingGrps !== '' &&
                // createCms64Data?.cmsReportingGrps !== '-1'
                //   ? rebatePrgByCMS?.map((item) => {
                //       item.rebateProgramCd = item.rebateProgramCode;
                //       item.shortDescr = item.shortDesc;
                //       return item;
                //     })
                //   : []
                groupRebateProgramData
              }
              fileName="G-Rebate Program Grid"
            />
          </div>
        )}
      </div>
      <CommonModal
        className="dialogPanel frr-rightAlignment custom-check dialog-500"
        open={confirmModal && confirmModal !== '' && confirmModal != null}
        onClose={() => setConfirmModal(false)}
        onOk={() => {
          setConfirmModal(false);
          runProcess(true, true, typeof createCmsReport === 'string');
        }}
        okTitle="Yes"
        modalTitle="Confirmation"
        childrenComponent={<div>{confirmModal}</div>}
        viewHeader
        viewAction
        closeTitle="No"
      />
    </div>
  );
}
export default withRouter(ReqInitCorrectCmsReport);
